import { Resources } from "../Resources/Intercom.Resources.DevPortal";

/**
 * Helper function for localizing a list of words. Doesn't support the Oxford comma.
 * Examples:
 *  ["apple", "orange", "pear", "peach"] => "apple, orange, pear and peach"
 *  ["apple"] => "apple"
 *  ["apple", "orange"] => "apple and orange"
 * If there's a language where conjunctions happen only at the beginning of a series
 * (ie, "apple and orange, pear, peach"), or that modify conjunctions (based on 
 * plurality, gendered nouns, or length of series), this function will have trouble.
 */
export function localizeAndList(input:string[]):string {
    if (input.length === 1) {
        return input[0];
    } else {
        let result = "";
        for (let i = 0; i < input.length - 2; i++) {
            result += Resources.listElem.replace("{0}", input[i]);
        }
        result += Resources.andListEnd
            .replace("{0}", input[input.length - 2])
            .replace("{1}", input[input.length - 1]);
        return result;
    }
}


// WEBPACK FOOTER //
// ./Client/Utils/LocalizationUtils.ts